export { default as component } from "../../../../src/routes/[prefix]/(feature)/info/+page.svelte";